import "../common/ControlBtn/index.css";
import "./index.css";

import { ReactComponent as MinusBtnSvg } from "./minusBtn.svg";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export default function MinusBtn(props: Props) {
  return (
    <button
      type="button"
      {...props}
      className={[
        "bordered atomic atoms simple-part minus-btn bg-white control-btn",
        props.className
      ].join(" ")}
    >
      <MinusBtnSvg />
    </button>
  );
}
